import React from 'react';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import TeleConsultationStore from '../DataRepo/TeleConsultationStore';
import { useEffect, useState, useRef } from 'react';
import { Button } from '@mui/material';
import { useParams, useNavigate, Link } from 'react-router-dom';
import aiwelllogo from '../Assets/images/Aiwell Logo 1 1.png'
import { CircularProgress } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem, TextField, Slider } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { getUserDetails } from '../Auth/AuthUtil';
import useCartStore from '../DataRepo/CartStore';
import { Badge } from '@mui/material';
import loadingimg from '../Assets/images/loading image 1.png';
import addtocart from '../Assets/images/add_to _bag_brown.png'
import MedicineCard from './MedicineCard';
import PatientDetailItem from './PatientDetailItem';

function ViewPrescription() {


    const { getOnePrescription, PrescriptionOneData, isPrescriptionOneLoading } = TeleConsultationStore();


    const { id } = useParams();

    const userDetails = getUserDetails();

    const { cartItems, getCart } = useCartStore();

    const navigate = useNavigate();

    const audioRef = useRef(null);


    const [isPlaying, setIsPlaying] = useState(false);

    const ratings = ["None", "Mild", "Moderate", "High", "Severe", "Extreme"];

    const handleDownload = (s3Link) => {
        const link = document.createElement('a');
        link.href = s3Link;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
        setIsPlaying(!isPlaying);
    };



    const headerStyle = {
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 500,
        color: "#3B362A",
        fontSize: "16px",
        padding: "10px"
    };

    const cellStyle = {
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 400,
        color: "#3B362A",
        fontSize: "15px",
        padding: "10px"
    };

    const vitalSignMeta = {
        bloodPressure: { label: "Blood Pressure", unit: "mmHg" },
        pulseRate: { label: "Pulse Rate", unit: "bpm" },
        respiratoryRate: { label: "Respiratory Rate", unit: "breaths/min" },
        randomBloodSugar: { label: "Random Blood Sugar", unit: "mg/dL" },
        oximeterValue: { label: "Oximeter Value", unit: "%" },
        temperature: { label: "Temperature", unit: "°F" },
        weight: { label: "Weight", unit: "kg" },
        height: { label: "Height", unit: "cm" },
        bmi: { label: "BMI", unit: "kg/m²" }
    };

    useEffect(() => {
        getOnePrescription(id)
        getCart()
    }, []);

    return (
        <div className='All-products-section-main'>

            <nav className='flex flex-row p-2 items-center justify-between'>
                <div className='flex flex-row items-center'>
                    <IconButton onClick={() => navigate(-1)}>
                        <ChevronLeft />
                    </IconButton>
                    <p className='mb-0'>Prescription</p>
                </div>
            </nav>

            <div className='Reports-main-page'>
                <div className='Reports-text-box'>
                    <div className='flex flex-row justify-between item-center m-2'>
                        <p>{PrescriptionOneData?.Date}</p>
                        <div>
                            <audio ref={audioRef}>
                                <source src={PrescriptionOneData?.Audio_Prescription} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <IconButton onClick={handlePlayPause} style={{ color: "#DA6E0B" }}>
                                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                            <p>Audio Prescription</p>
                        </div>
                    </div>

                    <div className='flex flex-row justify-center align-items-center' >
                        {isPrescriptionOneLoading ? (
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
                                <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                                    <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                                    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div>

                                <div className="header">
                                    <img
                                        src={aiwelllogo}
                                        alt="Aiwell Logo"
                                    />
                                    <div className="prescription-doctor-details">
                                        <p>{PrescriptionOneData?.Doctor_details?.name} &nbsp;
                                            <span style={{ fontSize: "12px" }}>{PrescriptionOneData?.Doctor_details?.course_details}</span></p>
                                        <p style={{ fontSize: "12px" }}>
                                            Register No: {PrescriptionOneData?.Doctor_details?.regno}</p>
                                        <p >{PrescriptionOneData?.Doctor_details?.speciality}</p>
                                        <p >Ayurvedic Physician</p>
                                    </div>
                                </div>

                                <div className="w-full px-4 md:px-8 lg:px-12 py-6">

                                    <div>
                                        <p className="Prescription-sh-h">Patient Details</p>
                                        <div className="Patient-details">
                                            <PatientDetailItem label="Name" value={`${PrescriptionOneData?.Patient_details?.firstname} ${PrescriptionOneData?.Patient_details?.lastname}`} />
                                            <PatientDetailItem label="Age" value={PrescriptionOneData?.Patient_details?.dob} />
                                            <PatientDetailItem label="Gender" value={PrescriptionOneData?.Patient_details?.gender} />
                                            <PatientDetailItem label="Height" value={
                                                PrescriptionOneData?.Patient_details?.height_unit === "ft"
                                                    ? `${PrescriptionOneData?.Patient_details?.height_ft}'${PrescriptionOneData?.Patient_details?.height_in}"`
                                                    : `${PrescriptionOneData?.Patient_details?.height} ${PrescriptionOneData?.Patient_details?.height_unit || "cm"}`
                                            } />
                                            <PatientDetailItem label="Weight" value={
                                                PrescriptionOneData?.Patient_details?.weight_unit === "lbs"
                                                    ? `${PrescriptionOneData?.Patient_details?.weight_lbs || ""} lbs`
                                                    : `${PrescriptionOneData?.Patient_details?.weight_kg || ""} kg`
                                            } />
                                            <PatientDetailItem label="BMI" value={PrescriptionOneData?.Patient_details?.bmi ? `${PrescriptionOneData?.Patient_details?.bmi} kg/m²` : ''} />
                                        </div>
                                    </div>

                                    {PrescriptionOneData?.ChiefComplaints?.length > 0 && (
                                        <div className="w-full mt-5">
                                            <p className="Prescription-sh-h">
                                                Chief Complaints
                                            </p>

                                            {/* ✅ Table View for Tablets and Desktops */}
                                            <div className="hidden md:block overflow-x-auto">
                                                <table className="min-w-full text-sm text-left text-gray-700 font-poppins">
                                                    <thead className="bg-[#D4CEC3] text-[#3B362A] text-sm md:text-base font-medium">
                                                        <tr>
                                                            <th className="px-4 py-2 text-center">Symptom</th>
                                                            <th className="px-4 py-2 text-center">Severity</th>
                                                            <th className="px-4 py-2 text-center">Duration</th>
                                                            <th className="px-4 py-2 text-center">Frequency</th>
                                                            <th className="px-4 py-2 text-center">Goal</th>
                                                            <th className="px-4 py-2 text-center"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-[#F8F8F4]">
                                                        {PrescriptionOneData.ChiefComplaints.map((e, i) => (
                                                            <tr key={i} className="border-t">
                                                                <td className="px-4 py-3 text-center text-sm md:text-base">{e?.symptoms}</td>
                                                                <td className="px-4 py-3">
                                                                    <div className="flex items-center justify-center gap-3">
                                                                        {ratings?.map((label, index) => (
                                                                            <div key={index} className="flex flex-col items-center">
                                                                                <div
                                                                                    className={`w-5 h-5 md:w-6 md:h-6 rounded-full ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                        }`}
                                                                                ></div>
                                                                                <span className="text-[10px] md:text-xs mt-1">{label}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </td>
                                                                <td className="px-4 py-3 text-center text-sm md:text-base">{e?.duration}</td>
                                                                <td className="px-4 py-3 text-center text-sm md:text-base">{e?.frequeny}</td>
                                                                <td className="px-4 py-3 text-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={e?.goal}
                                                                        readOnly
                                                                        onClick={(e) => e.preventDefault()}
                                                                        className="w-4 h-4 accent-[#DA6E0B] cursor-default"
                                                                    />
                                                                </td>
                                                                <td className="px-4 py-3"></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="block md:hidden space-y-4">
                                                {PrescriptionOneData.ChiefComplaints.map((e, i) => (
                                                    <div key={i} className="bg-[#F8F8F4] p-4 rounded-lg shadow text-sm font-poppins">
                                                        <div className="mb-2 flex items-center gap-5">
                                                            <span className="font-semibold text-[#3B362A]">Symptom:</span>{" "}
                                                            <span className="text-[#3B362A]">{e?.symptoms}</span>
                                                        </div>
                                                        <div className="mb-2 flex items-center gap-5">
                                                            <span className="font-semibold text-[#3B362A]">Severity:</span>
                                                            <div className="flex items-center gap-2 mt-1">
                                                                {ratings?.map((label, index) => (
                                                                    <div key={index} className="flex flex-col items-center">
                                                                        <div
                                                                            className={`w-4 h-4 rounded-full ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                }`}
                                                                        ></div>
                                                                        <span className="text-[10px]">{label}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <div className="mb-2 flex items-center gap-5">
                                                            <span className="font-semibold text-[#3B362A]">Duration:</span>{" "}
                                                            <span className="text-[#3B362A]">{e?.duration}</span>
                                                        </div>
                                                        <div className="mb-2 flex items-center gap-5">
                                                            <span className="font-semibold text-[#3B362A]">Frequency:</span>{" "}
                                                            <span className="text-[#3B362A]">{e?.frequeny}</span>
                                                        </div>
                                                        <div className='flex items-center gap-5'>
                                                            <span className="font-semibold text-[#3B362A]">Goal:</span>
                                                            <input
                                                                type="checkbox"
                                                                checked={e?.goal}
                                                                readOnly
                                                                onClick={(e) => e.preventDefault()}
                                                                className="ml-2 w-4 h-4 accent-[#DA6E0B] cursor-default"
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
    
                                    {PrescriptionOneData?.PastHistory && PrescriptionOneData?.PastHistory?.length > 0 &&
                                        <div>
                                            <p className="Prescription-sh-h">Past History</p>
                                            <div style={{ padding: '1rem' }}>
                                                <TableContainer>
                                                    <Table aria-label="symptoms table">
                                                        <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                            <TableRow>
                                                                <TableCell sx={{ width: '30%' }} align="center"
                                                                    style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                        padding: "10px"
                                                                    }}>Ayurveda Disease</TableCell>
                                                                <TableCell sx={{ width: '30%' }} align="center"
                                                                    style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                        padding: "10px"
                                                                    }}>Modern Disease</TableCell>
                                                                <TableCell sx={{ width: '40%' }} align="center" style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "#3B362A",
                                                                    fontSize: "16px",
                                                                    padding: "10px"
                                                                }}>Severity</TableCell>
                                                                <TableCell sx={{ width: '30%' }} align="center"
                                                                    style={{
                                                                        fontFamily: "'Poppins', sans-serif",
                                                                        fontWeight: 500,
                                                                        color: "#3B362A",
                                                                        fontSize: "16px",
                                                                        padding: "10px"
                                                                    }}>Duration</TableCell>

                                                                <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                            {PrescriptionOneData?.PastHistory?.map((e, i) => (
                                                                <TableRow key={i}>
                                                                    <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                                        <p style={{
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontWeight: 500,
                                                                            color: "#3B362A",
                                                                            fontSize: "16px",
                                                                        }}>{e?.ayurvedaDisease}</p>
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                                        <p style={{
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontWeight: 500,
                                                                            color: "#3B362A",
                                                                            fontSize: "16px",
                                                                        }}>{e?.modernDisease}</p>
                                                                    </TableCell>
                                                                    <TableCell sx={{ width: '40%' }}>
                                                                        <div className="flex items-center justify-center space-x-6">
                                                                            {ratings?.map((label, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    className="flex flex-col items-center cursor-pointer"
                                                                                >
                                                                                    <div
                                                                                        className={`w-6 h-6 rounded-full transition-all duration-300 ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                            }`}
                                                                                    ></div>
                                                                                    <span className="mt-2 text-sm text-gray-700" style={{
                                                                                        fontFamily: "'Poppins', sans-serif",
                                                                                        fontWeight: 400,
                                                                                    }}>{label}</span>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell align="center" sx={{ width: '30%' }}>
                                                                        <p style={{
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontWeight: 500,
                                                                            color: "#3B362A",
                                                                            fontSize: "16px",
                                                                        }}>{e?.duration}</p>
                                                                    </TableCell>


                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    }

                                    {PrescriptionOneData?.MenstrualDetails &&
                                        Object.keys(PrescriptionOneData?.MenstrualDetails).length > 0 && (
                                            <div className="w-full mt-5">
                                                <p className="Prescription-sh-h">
                                                    Menstruation / Obstetrical
                                                </p>

                                                <div className="p-5 flex flex-col gap-5">
                                                    {Object.entries(PrescriptionOneData?.MenstrualDetails).map(([key, val]) => (
                                                        <div
                                                            key={key}
                                                            className="flex flex-col sm:flex-row sm:items-start sm:gap-2 text-sm md:text-base"
                                                        >
                                                            <p className="font-semibold text-[#DA6E0B] whitespace-nowrap">
                                                                {key
                                                                    ?.replace(/([A-Z])/g, " $1")
                                                                    ?.replace(/^./, (str) => str.toUpperCase())}:
                                                            </p>
                                                            <p className="text-[#3B362A] break-words">
                                                                {typeof val === "object"
                                                                    ? `${val?.answer || ""}${val?.details ? ` - ${val?.details}` : ""}`
                                                                    : val}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                    )}

                                    {PrescriptionOneData?.AI_Reports?.length > 0 && (
                                        <div>
                                            <p className="Prescription-sh-h">AI Reports</p>
                                            <div style={{ padding: '1rem' }}>
                                                <TableContainer>
                                                    <Table aria-label="lab results table">
                                                        <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                            <TableRow>
                                                                <TableCell align="center" style={headerStyle}>Name</TableCell>
                                                                <TableCell align="center" style={headerStyle}>Value</TableCell>
                                                                <TableCell align="center" style={headerStyle}>Reference Range</TableCell>
                                                                <TableCell align="center" style={headerStyle}>Status</TableCell>
                                                                <TableCell align="center" style={headerStyle}>Remarks</TableCell>
                                                                <TableCell align="center" style={headerStyle}>Goal</TableCell>

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                            {PrescriptionOneData.AI_Reports.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center" style={cellStyle}>{item.name}</TableCell>
                                                                    <TableCell align="center" style={cellStyle}>{item.value}</TableCell>
                                                                    <TableCell align="center" style={cellStyle}>{item.reference_range}</TableCell>
                                                                    <TableCell align="center" style={{
                                                                        ...cellStyle,
                                                                        color: item.type === "abnormal" ? "#DA6E0B" : "#3B362A",
                                                                        fontWeight: 600,
                                                                        textTransform: "capitalize"
                                                                    }}>
                                                                        {item.status}
                                                                    </TableCell>
                                                                    <TableCell align="left" style={{ ...cellStyle, fontSize: '14px' }}>
                                                                        {item.reason}
                                                                    </TableCell>
                                                                    <TableCell align="center" sx={{ width: '30%' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={item?.goal}
                                                                            readOnly
                                                                            onClick={(e) => e.preventDefault()}
                                                                            style={{
                                                                                width: '16px',
                                                                                height: '16px',
                                                                                accentColor: '#DA6E0B',
                                                                                cursor: 'default',
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    )}

                                    {
                                        PrescriptionOneData?.AyurvedaParameters && PrescriptionOneData?.AyurvedaParameters.length > 0 &&
                                        PrescriptionOneData?.AyurvedaParameters?.some(p => p.value?.trim() !== "") &&
                                        <div>
                                            <p className="Prescription-sh-h">Ayurveda Parameters</p>
                                            <ul className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 p-5'>
                                                {PrescriptionOneData?.AyurvedaParameters.map((e, i) => (
                                                    <li key={i} className='text-sm'>
                                                        <strong>{e.parameter}</strong>: {e?.value}
                                                    </li>
                                                ))}
                                            </ul>

                                        </div>
                                    }

                                    {PrescriptionOneData?.VitalSigns &&
                                        Object.values(PrescriptionOneData.VitalSigns).some(val => val?.trim?.() !== "") && (
                                            <div>
                                                <p className="Prescription-sh-h">Vital Signs</p>
                                                <div className="Medical-details">
                                                    {Object.entries(PrescriptionOneData.VitalSigns)
                                                        .filter(([_, value]) => value?.trim?.() !== "")
                                                        .map(([key, value]) => {
                                                            const meta = vitalSignMeta[key] || { label: key, unit: "" };
                                                            return (
                                                                <div key={key} className="flex items-center gap-2 mb-2">
                                                                    <p style={{ fontWeight: 500 }}>{meta.label}:</p>
                                                                    <p>{value} {meta.unit}</p>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>)}

                                   
                                    {PrescriptionOneData?.Medical_details &&
                                        Object.values(PrescriptionOneData?.Medical_details)?.some(val => val.trim() !== "") && (
                                            <div className="w-full">
                                                <p className="Prescription-sh-h">
                                                    Diagnosis
                                                </p>

                                                <div className="flex flex-col md:flex-row md:items-center md:gap-8 gap-4 w-full p-4 bg-[#F8F8F4] rounded-lg">
                                                    <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-2 text-sm md:text-base">
                                                        <p className="font-semibold text-[#DA6E0B]">Ayurveda Diagnosis:</p>
                                                        <p className="text-[#3B362A] break-words">
                                                            {PrescriptionOneData?.Medical_details?.ayurvedadiagnosis}
                                                        </p>
                                                    </div>
                                                    <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-2 text-sm md:text-base">
                                                        <p className="font-semibold text-[#DA6E0B]">Modern Diagnosis:</p>
                                                        <p className="text-[#3B362A] break-words">
                                                            {PrescriptionOneData?.Medical_details?.moderndiagnosis}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {
                                        PrescriptionOneData?.labTests &&
                                        PrescriptionOneData?.labTests?.length > 0 && < div >
                                            <p className="Prescription-sh-h">Lab Tests</p>
                                            <div className='labtestlistn flex items-center p-5'>
                                                {
                                                    PrescriptionOneData?.labTests.map((e, i) => {
                                                        return <div className='labtestitem'>
                                                            <p>{e}</p>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    }

                                    {PrescriptionOneData?.Supplements &&
                                        <div>
                                            <div className='flex items-center justify-between'>
                                                <p className="Prescription-sh-h">Medicines</p>
                                                <IconButton component={Link} to="/Checkout">
                                                    <Badge badgeContent={cartItems?.length} color="error">
                                                        <div className='nav-icons'>
                                                            <img src={addtocart} alt="Cart" />
                                                        </div>
                                                    </Badge>
                                                </IconButton>
                                            </div>

                                            <div className='Supplement-medicine-card-container'>
                                                {PrescriptionOneData?.Supplements &&
                                                    PrescriptionOneData?.Supplements.filter(e => e?.id !== '').map((e, i) => (
                                                        <MedicineCard key={i} medicine={e} />
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    }

                                    {PrescriptionOneData?.Supplements &&
                                        PrescriptionOneData?.Supplements.some(e => e?.id === '') ?
                                        <div>
                                            <p className="Prescription-sh-h">Other Medicines</p>
                                            <div className='Supplement-medicine-card-container'>
                                                {PrescriptionOneData?.Supplements &&
                                                    PrescriptionOneData?.Supplements.filter(e => e?.id === '')?.map((e, i) => {
                                                        return <div className='Supplement-medicine-card' onClick={() => {
                                                            e.id != '' &&
                                                                navigate(`/Product?id=${e.id}`)
                                                        }}>
                                                            <div className='flex flex-row gap-10'>

                                                                <div className='Supplement-medicine-card-image'>
                                                                    {e.id != '' ?
                                                                        <img src={e?.imgurl} alt="Medicine Image" ></img>
                                                                        :
                                                                        <img src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png" alt="Medicine Image" />
                                                                    }
                                                                </div>

                                                                <div className='Supplement-medicine-card-info'>
                                                                    <p>{e.medicine}</p>

                                                                    <div>
                                                                        <p><span>Dose</span>: {e?.dose}</p>
                                                                        <p><span>Order Quantity</span>: {e?.quantity}</p>
                                                                        <p><span>Duration</span> : {e?.duration}</p>
                                                                        <p><span>Product Link</span> : <a href={e?.productlink} target='_blank'>
                                                                            Click here</a></p>
                                                                        <p><span>Instruction</span> : {e?.instruction}</p>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            {e.id === '' && <p style={{ fontSize: "8px" }}>
                                                                This product is not available on our platform.</p>}

                                                        </div>
                                                    })
                                                }
                                            </div>

                                        </div> : <></>

                                    }

                                    {PrescriptionOneData?.Diet?.included?.length > 0 ||
                                        PrescriptionOneData?.Diet?.avoided?.length > 0 ? (
                                        <div className="after-page-break">
                                            <p className="Prescription-sh-h">Diet</p>
                                            <div className="container">

                                                {PrescriptionOneData?.Diet?.included?.length > 0 && (
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div className="icon">✅</div>
                                                            <p>Food to be Included</p>
                                                        </div>
                                                        <div className="card-content">
                                                            {PrescriptionOneData?.Diet?.included?.map(
                                                                (e, i) => (
                                                                    <div key={i}>
                                                                        <img
                                                                            src={e?.imageLink}
                                                                            alt={e?.englishName}
                                                                        />
                                                                        <p>{e?.englishName}</p>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {PrescriptionOneData?.Diet?.avoided?.length > 0 && (
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <div className="icon">❌</div>
                                                            <p>Food to be Minimal</p>
                                                        </div>
                                                        <div className="card-content">
                                                            {PrescriptionOneData?.Diet?.avoided?.map(
                                                                (e, i) => (
                                                                    <div key={i}>
                                                                        <img
                                                                            src={e?.imageLink || 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png'}
                                                                            alt={e?.englishName}
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png';
                                                                            }}
                                                                        />

                                                                        <p>{e?.englishName}</p>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ) : null}

                                    {PrescriptionOneData?.Recipes?.length > 0 && (
                                        <div className="after-page-break">
                                            <p className="Prescription-sh-h">Recipes</p>
                                            <div className="item-container">
                                                {PrescriptionOneData?.Recipes?.map((e, i) => (
                                                    <div key={i} className="item">
                                                        <img
                                                            src={e?.imageLink || 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png'}
                                                            alt={e.recipe}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png';
                                                            }}
                                                        />
                                                        <p>{e.recipe}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {PrescriptionOneData?.Practices && (
                                        <div className="after-page-break">
                                            <p className="Prescription-sh-h">Lifestyle Practices</p>
                                            <div className="lifestyle-container">

                                                {PrescriptionOneData?.Practices?.yoga?.length > 0 && (
                                                    <div className="lifestyle-card">
                                                        <div className="lifestyle-card-header">Yoga</div>
                                                        <div className="lifestyle-card-content">
                                                            <ul className="list-none">
                                                                {PrescriptionOneData?.Practices?.yoga?.map((e, i) => (
                                                                    <li
                                                                        key={i}
                                                                        onClick={() => navigate(`/Yoga?id=${e?.id}`)}
                                                                        className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                                    >
                                                                        <span className="whitespace-nowrap">{e.title}</span>
                                                                        <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                                        {e.reps ? (
                                                                            <span className="whitespace-nowrap text-sm">{e.reps} reps</span>
                                                                        ) : null}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}

                                                {PrescriptionOneData?.Practices?.pranayama?.length > 0 && (
                                                    <div className="lifestyle-card">
                                                        <div className="lifestyle-card-header">Pranayama</div>
                                                        <div className="lifestyle-card-content">
                                                            <ul className="list-none">
                                                                {PrescriptionOneData?.Practices?.pranayama?.map((e, i) => (
                                                                    <li
                                                                        key={i}
                                                                        onClick={() => navigate(`/Pranayama?id=${e?.id}`)}
                                                                        className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                                    >
                                                                        <span className="whitespace-nowrap">{e.title}</span>
                                                                        <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                                        {e.reps ? (
                                                                            <span className="whitespace-nowrap text-sm">{e.reps} reps</span>
                                                                        ) : null}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}

                                                {PrescriptionOneData?.Practices?.meditation?.length > 0 && (
                                                    <div className="lifestyle-card">
                                                        <div className="lifestyle-card-header">Meditation</div>
                                                        <div className="lifestyle-card-content">
                                                            <ul className="list-none">
                                                                {PrescriptionOneData?.Practices?.meditation?.map((e, i) => (
                                                                    <li
                                                                        key={i}
                                                                        onClick={() => navigate(`/Meditation?id=${e?.Id}`)}
                                                                        className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                                    >
                                                                        <span className="whitespace-nowrap">{e.title}</span>
                                                                        <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                                        {e.duration ? (
                                                                            <span className="whitespace-nowrap text-sm">{e.duration} min</span>
                                                                        ) : null}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    )}

                                    {PrescriptionOneData?.LifeStyle_changes?.length > 0 && (
                                        <div className="after-page-break">
                                            <p className="Prescription-sh-h">LifeStyle Changes</p>
                                            <div className="LifeStyle-changes-Container">
                                                <ul className="list-disc ml-5">
                                                    {PrescriptionOneData?.LifeStyle_changes.map((e, i) => (
                                                        <li key={i}>{e}</li>
                                                    ))}
                                                </ul>
                                            </div>

                                        </div>
                                    )}


                                    <div className='flex flex-row items-center justify-center mt-10 mb-10'>
                                        <div className='prescription-buy-now'>
                                            <Button
                                                style={{
                                                    width: '100%',
                                                    textTransform: 'none',
                                                    backgroundColor: '#DA6E0B',
                                                    color: 'white',
                                                    border: 'none',
                                                    boxSizing: 'border-box',
                                                    borderRadius: '5px',
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                    padding: '10px'
                                                }}

                                                onClick={() => handleDownload(PrescriptionOneData?.Prescription)}
                                            >
                                                <DownloadIcon />&nbsp; Download Prescription
                                            </Button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewPrescription;
